<template>

    <div>
        <template v-if="tool && step === 3">

            <div class="row mt-3">
                <div class="col-8 offset-2">
                    <h6>1. {{ $t("Select Icon") }}</h6>
                    <div class="row toolTypes">

                        <div :class="tool.icon === 'custom' ? 'selected' : ''"
                             class="offset-1 col-4 text-center toolType"
                             @click="tool.icon = 'custom'">
                            <Icon
                                bottom-text="TST"
                                class="mb-3"
                                color="#000000"
                                middle-text="5"
                                tool-icon="custom"
                                tool-type="firestop"
                                top-text="DET1"
                            ></Icon>
                            <h4>{{ $t("Installed") }}</h4>
                            <p class="info"
                               v-html="$t('You may use this to markup tool to present installed firestops')"></p>
                        </div>
                    </div>

                    <template v-if="tool.icon">
                        <h6>2. {{ $t("Add detail into icon") }}</h6>
                        <p class="info"
                           v-html="$t('In this section you can add optional details into your icon to be shown with the icon. You can skip this if wanted.')">

                        </p>
                        <div class="row">
                            <div class="offset-1 col-3 text-center toolType">
                                <Icon
                                    :bottom-text="tool.show_lower_detail ? (tool.icon === 'red-pen' ? 'TST_1' : 'TST') : (tool.icon === 'red-pen' ? '1' : '')"
                                    :middle-text="tool.icon === 'red-pen' ? '!' : '1'"
                                    :tool-icon="tool.icon"
                                    :tool-type="tool.type"
                                    :top-text="tool.show_upper_detail ? 'DET1' : ''"
                                    class="mb-3"
                                    color="#000000"
                                ></Icon>
                            </div>
                            <div class="col-8">
                                <div :class="tool.show_upper_detail ? 'checked' : ''" class="check-box"
                                     @click="tool.show_upper_detail = !tool.show_upper_detail">
                                    {{ $t("Show detail") }}
                                </div>

                                <div class="check-box checked disabled">
                                    {{ $t("Show running number") }}
                                </div>

                                <div :class="tool.show_lower_detail ? 'checked' : ''" class="check-box"
                                     @click="tool.show_lower_detail = !tool.show_lower_detail">
                                    {{ $t("Show short name") }}

                                </div>
                            </div>
                        </div>

                    </template>
                </div>
            </div>

        </template>

        <template v-if="tool && step === 4">
            <div class="mt-3 offset-4 col-3 text-center toolType">

                <Icon
                    :bottom-text="tool.show_lower_detail ? (tool.icon === 'red-pen' ? tool.short_name + '_1' : tool.short_name) : (tool.icon === 'red-pen' ? '1' : '')"
                    :middle-text="tool.icon === 'red-pen' ? '!' : '1'"
                    :tool-icon="tool.icon"
                    :tool-type="tool.type"
                    :top-text="tool.show_upper_detail ? 'DET1' : ''"
                    class="mb-3"
                    color="#000000"
                ></Icon>

            </div>

            <div class="row">
                <div class="col-8 offset-2">
                    <div class="form-group mb-0">

                        <b-form-input
                            id="tool-long-name"
                            v-model="tool.long_name"
                            :state="errors.long_name === null"
                            @input="errors.long_name = null"
                            required
                            :placeholder="$t('Full Tool Name') + ' (*)'"
                            maxlength="25"
                        ></b-form-input>
                    </div>

                    <b-alert :show="errors.long_name !== null" variant="danger">{{ errors.long_name }}</b-alert>

                    <p class="info mt-0 pt-0 pl-3">
                        {{
                            $t('This will appear as the default headline in your report for the tool (can be changed manually after adding the marking)')
                        }}.
                        <br/>{{ $t('Max characters', {characters: 25}) }}.
                    </p>

                    <div class="form-group mb-0">

                        <b-form-input
                            id="tool-short-name"
                            v-model="tool.short_name"
                            :state="errors.short_name === null"
                            @input="errors.short_name = null"
                            required
                            :placeholder="$t('Short Tool Name') + '(' + $t('shows on tablet / mobile') + ')' + ' (*)'"
                            maxlength="5"
                        ></b-form-input>
                    </div>

                    <b-alert :show="errors.short_name !== null" variant="danger" v-if="errors.short_name !== null">
                        {{ errors.short_name }}
                    </b-alert>

                    <p class="info mt-0 pt-0 pl-3">
                        {{ $t('This name appears in application, and helps to recognise between design markings') }}.
                        <br/> {{ $t('Max characters', {characters: 5}) }}.
                    </p>


                    <div class="form-group mb-0">
                            <textarea v-model="tool.description"
                                      :placeholder="$t('Description') + ' (' + $t('optional') +')'"
                                      class="form-control"
                                      maxlength="255">
                            </textarea>
                    </div>
                    <p class="info mt-0 pt-0 pl-3">
                        {{ $t("This tool description shows in tool's infobox, when descriptions is requested") }}.
                        <br/> {{ $t('Max characters', {characters: 255}) }}.
                    </p>
                </div>
            </div>


        </template>

        <template v-if="tool && step === 5">
            <div class="row mt-3">
                <div class="col-8 offset-2">
                    <h6 :class="tool.catalog_2 ? 'checked' : ''" class="statusTitle"
                        @click="toggleCatalog(2, $t('Detail'), [''])">
                        {{ $t("Firestop details (as marked on the plan)") }}
                    </h6>
                    <p class="info">
                        {{
                            $t("In this section you can add optional details into your icon to be shown with the icon. You can skip this if wanted.")
                        }}
                    </p>


                </div>
            </div>


            <div class="row mt-3">
                <div class="col-8 offset-2">
                    <template v-if="tool.catalog_2_values && tool.catalog_2_values.length > 0">
                        <div v-for="(catalogValue, key) in tool.catalog_2_values" class="form-group">

                            <b-form-input
                                :value="catalogValue && catalogValue.text ? catalogValue.text : ''"
                                :state="errors.catalog_2_values === null"
                                @input="errors.catalog_2_values = null"
                                required
                                :placeholder="$t('Firestop Detail Name')"
                                maxlength="10"
                                @change="changeCatalogValue(2, key, $event)"
                            ></b-form-input>


                            <button v-if="key !== 0" class="remove"
                                    @click="tool.catalog_2_values.splice(key, 1)"></button>
                        </div>
                    </template>

                    <b-alert :show="errors.catalog_2_values !== null" variant="danger"
                             v-if="errors.catalog_2_values !== null">{{ errors.catalog_2_values }}
                    </b-alert>

                    <a v-if="tool.catalog_2_values && tool.catalog_2_values.length < 100" class="underline"
                       href="javascript:void(0)" @click="addValueToCatalog('', '', 2)">
                        <b-icon icon="plus"></b-icon>
                        {{ $t("Add a new detail") }}
                    </a>
                </div>
            </div>


        </template>

        <template v-if="tool && step === 6">

            <div class="row mt-3">
                <div class="col-8 offset-2">
                    <h6>{{ $t("Select a product to add it to your product list") }}</h6>

                    <div class="form-group">
                        <b-form-select v-model="selectedProduct" @change="addProductToTool">
                            <b-form-select-option :value="null">
                                {{ $t("Select a product to add it to your product list") }}
                            </b-form-select-option>
                            <template v-if="products && products.length > 0">
                                <b-form-select-option v-for="product in products" :key="product.id" :value="product">
                                    {{ product.name }} {{ product.eta_ce ? '-' + product.eta_ce : '' }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>

                    <div class="multiSelectList">

                        <div v-for="(catalogValue, key) in tool.catalog_5_values" class="option">
                            <span>{{ catalogValue.text }}</span>
                            <button class="remove" @click="deleteProductByKey(key)"></button>
                        </div>
                    </div>
                </div>
            </div>


        </template>

        <template v-if="tool && step === 7">

            <div class="row mt-3">
                <div class="col-8 offset-2">
                    <h6 :class="tool.catalog_3 ? 'checked' : ''" class="statusTitle"
                        @click="toggleCatalog(3, $t('Status'), defaultStatuses)">
                        {{ $t("Status") }}
                        <b-icon icon="caret-down-fill"></b-icon>
                    </h6>

                    <div class="mb-5">
                        <p class="info"
                           v-html="$t('This feature allows you to add dropdown selection box. Max 5 selections on one dropdown')"></p>

                        <div v-for="(catalogValue, key) in tool.catalog_3_values" class="form-group">

                            <b-form-input
                                v-if="tool.catalog_3"
                                :value="catalogValue && catalogValue.text ? catalogValue.text : ''"
                                :state="errors.catalog_3_values === null"
                                @input="errors.catalog_3_values = null"
                                required
                                :placeholder="$t('Status name')"
                                @change="changeCatalogValue(3, key, $event)"
                            ></b-form-input>

                            <button v-if="key !== 0" class="remove"
                                    @click="tool.catalog_3_values.splice(key, 1)"></button>
                        </div>

                        <b-alert :show="errors.catalog_3_values !== null" variant="danger"
                                 v-if="errors.catalog_3_values !== null">{{ errors.catalog_3_values }}
                        </b-alert>

                        <a v-if="tool.catalog_3_values && tool.catalog_3_values.length < 5 && tool.catalog_3"
                           class="underline"
                           href="javascript:void(0)"
                           @click="addValueToCatalog('', '', 3)">
                            <b-icon icon="plus"></b-icon>
                            {{ $t("Add another value") }}
                        </a>

                    </div>

                    <h6 :class="tool.catalog_4 ? 'checked' : ''" class="statusTitle"
                        @click="toggleCatalog(4, $t('Location'), defaultLocations)">
                        {{ $t("Location") }}
                        <b-icon icon="caret-down-fill"></b-icon>
                    </h6>


                    <div class="mb-5">
                        <p class="info"
                           v-html="$t('This feature allows you to add dropdown selection box. Max 5 selections on one dropdown')"></p>

                        <div v-for="(catalogValue, key) in tool.catalog_4_values" v-if="tool.catalog_4"
                             class="form-group">

                            <b-form-input
                                v-if="tool.catalog_4"
                                :value="catalogValue && catalogValue.text ? catalogValue.text : ''"
                                :state="errors.catalog_4_values === null"
                                @input="errors.catalog_4_values = null"
                                required
                                :placeholder="$t('Location name')"
                                @change="changeCatalogValue(4, key, $event)"
                            ></b-form-input>

                            <button v-if="key !== 0" class="remove"
                                    @click="tool.catalog_4_values.splice(key, 1)"></button>
                        </div>

                        <b-alert :show="errors.catalog_4_values !== null" variant="danger"
                                 v-if="errors.catalog_4_values !== null">{{ errors.catalog_4_values }}
                        </b-alert>

                        <a v-if="tool.catalog_4_values && tool.catalog_4_values.length < 5 && tool.catalog_4"
                           class="underline" href="javascript:void(0)"
                           @click="addValueToCatalog('', '', 4)">
                            <b-icon icon="plus"></b-icon>
                            {{ $t("Add another value") }}
                        </a>

                    </div>

                    <h6 :class="tool.catalog_1 ? 'checked' : ''" class="statusTitle"
                        @click="toggleCatalog(1, $t('Requires approval'), defaultApprovals)">
                        {{ $t("Requires approval") }}
                        <b-icon icon="caret-down-fill"></b-icon>
                    </h6>

                    <div class="approvals">
                        <p class="info"
                           v-html="$t('This is a function where site requests approval or comment on this marking or the marking requires approval.')"></p>
                        <div v-for="(catalogValue, key) in tool.catalog_1_values" v-if="tool.catalog_1"
                             class="mb-3" :key="key">
                            <div class="row">
                                <div class="col-1 offset-2 d-flex align-items-center">
                                    <template v-if="key < 3">
                                        <div :style="{backgroundColor: catalogValue.value, flexShrink: 0}" class="color"></div>
                                    </template>
                                    <template v-else>
                                        <ApprovalColorPicker v-model="catalogValue.value"/>
                                    </template>
                                </div>
                                <div class="col-8">
                                    <b-form-input
                                        class="approval"
                                        v-model="catalogValue.text"
                                        :state="errors.catalog_1_values === null"
                                        @input="errors.catalog_1_values = null"
                                        required
                                        :placeholder="$t('Approval text')"
                                    ></b-form-input>
                                </div>
                            </div>

                            <div class="row"
                                 v-if="key >= 3">
                                <div class="col-9 offset-2 text-right mt-1">
                                    <a class="underline ml-3"
                                       href="javascript:void(0)"
                                       @click="removeApprovalColor(key)">
                                        <b-icon icon="x-circle"></b-icon>
                                        {{ $t("Remove custom color") }}
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div v-if="tool.catalog_1" class="row mb-2">
                            <div class="col-9 offset-2">
                                <a v-if="tool.catalog_1_values.length < 3 + maxCustomApprovalColors"
                                   href="javascript:void(0)" class="underline" @click="addApprovalColor">
                                    <b-icon icon="plus"></b-icon>
                                    {{ $t("Add custom color") }}
                                </a>
                                <p v-else class="info mb-0">
                                    {{ $t('You can have') }} {{ maxCustomApprovalColors }} {{ $t('custom colors.') }}
                                </p>
                            </div>
                        </div>

                        <b-alert :show="errors.catalog_1_values !== null" variant="danger"
                                 v-if="errors.catalog_1_values !== null">{{ errors.catalog_1_values }}
                        </b-alert>

                    </div>

                </div>
            </div>


        </template>

        <template v-if="tool && step === 8">
            <div class="row mt-5">
                <div class="col-8 offset-2">

                    <p class="info">
                        {{
                            $t('This feature allows you to add dropdown selection box. You can have a maximum of x dropdowns and text boxes for a tool.', {max: 12})
                        }}
                    </p>

                    <h6 :class="hasCatalog ? 'checked' : ''" class="statusTitle"
                        @click="toggleCatalogInputs">
                        5.2 {{ $t("Add dropdown box") }}
                        <b-icon icon="caret-down-fill"></b-icon>
                    </h6>

                    <p class="info" v-if="hasCatalog">
                        {{ $t('Max x selections on one dropdown', {max: 12}) }}
                    </p>

                    <div v-if="hasCatalog" v-for="index in 20" :key="index" class="form-group">
                        <template v-if="index > 7 && tool['catalog_' + index] !== null">
                            <div class="form-group mb-3">
                                <b-form-input
                                    v-model="tool['catalog_' + index]"
                                    :state="errors['catalog_' + index] === null"
                                    @input="errors['catalog_' + index] = null"
                                    required
                                    :placeholder="$t('Dropdown headline') + ' (*)'"
                                ></b-form-input>
                            </div>

                            <b-alert :show="errors['catalog_' + index] !== null" variant="danger"
                                     v-if="errors['catalog_' + index] !== null">{{ errors['catalog_' + index] }}
                            </b-alert>

                            <div v-for="(value, valueIndex) in tool['catalog_' + index + '_values']"
                                 v-if="tool['catalog_' + index + '_values']"
                                 class="form-group mb-0">


                                <b-form-input
                                    :value="value && value.text ? value.text : ''"
                                    :state="errors['catalog_' + index + '_values'] === null"
                                    @input="errors['catalog_' + index + '_values'] = null"
                                    required
                                    :placeholder="$t('Add selection text') + ' (*)'"
                                    @change="changeCatalogValue(index, valueIndex, $event)"
                                ></b-form-input>

                                <button v-if="valueIndex !== 0" class="remove"
                                        @click="removeCatalogValue(index, valueIndex)"></button>
                            </div>

                            <b-alert :show="errors['catalog_' + index + '_values'] !== null" variant="danger"
                                     v-if="errors['catalog_' + index + '_values'] !== null">
                                {{ errors['catalog_' + index + '_values'] }}
                            </b-alert>

                            <div class="mt-3 row">
                                <div class="col-6">
                                    <a v-if="tool['catalog_' + index + '_values'] && tool['catalog_' + index + '_values'].length < maxSelectOptions"
                                       class="underline mt-3"
                                       href="javascript:void(0)" @click="tool['catalog_' + index + '_values'].push('')">
                                        <b-icon icon="plus"></b-icon>
                                        {{ $t("Add another selection box") }}
                                    </a>
                                </div>
                                <div class="col-6">
                                    <a class="underline mt-3 ml-3"
                                       href="javascript:void(0)"
                                       @click="confirmRemoveCatalog(index)">
                                        <b-icon icon="x-circle"></b-icon>
                                        {{ $t("Remove selection box") }}
                                    </a>
                                </div>
                            </div>
                        </template>
                    </div>

                    <hr/>

                    <a v-if="hasCatalog && customInputCount <= 12" class="underline mt-3"
                       href="javascript:void(0)" @click="addEmptyCatalog()">
                        <b-icon icon="plus"></b-icon>
                        {{ $t("Add another dropdown box") }}
                    </a>

                    <p v-if="hasCatalog && customInputCount >= 12" class="info">
                        {{ $t('You have reached the maximum number of custom inputs (selection and text boxes)') }}
                    </p>

                </div>
            </div>

            <div class="row mt-5">
                <div class="col-8 offset-2">
                    <h6 :class="hasTextBox ? 'checked' : ''" class="statusTitle"
                        @click="toggleTextBoxInputs">
                        6.1 {{ $t("Add text box") }}
                        <b-icon icon="caret-down-fill"></b-icon>
                    </h6>

                    <div v-if="hasTextBox" v-for="index in 12" :key="index" class="form-group">
                        <template v-if="index > 1 && tool['text_' + index] !== null">
                            <div class="form-group mb-3">

                                <b-form-input
                                    v-model="tool['text_' + index]"
                                    :state="errors['text_' + index] === null"
                                    @input="errors['text_' + index] = null"
                                    required
                                    :placeholder="$t('Text box headline') + ' (*)'"
                                ></b-form-input>

                                <button class="remove"
                                        @click="disableTextBox(index)"></button>

                                <b-alert :show="errors['text_' + index] !== null" variant="danger"
                                         v-if="errors['text_' + index] !== null">{{ errors['text_' + index] }}
                                </b-alert>
                            </div>


                        </template>
                    </div>

                    <hr/>
                    <a v-if="hasEmptyTextBox && hasTextBox && customInputCount < 12" class="underline mt-3"
                       href="javascript:void(0)" @click="addEmptyTextBox()">
                        <b-icon icon="plus"></b-icon>
                        {{ $t("Add another text box") }}
                    </a>
                    <p v-if="hasTextBox && customInputCount >= 12" class="info">
                        {{ $t('You have reached the maximum number of custom inputs (selection and text boxes)') }}
                    </p>


                </div>
            </div>
        </template>

        <template v-if="tool && step === 9">
            <div class="row mt-3">
                <div class="col-8 offset-2 preview pb-3">

                    <div class="row mb-4">
                        <div class="offset-4 col-3 toolIcon text-center toolType">
                            <Icon
                                :bottom-text="tool.show_lower_detail ? (tool.icon === 'red-pen' ? tool.short_name + '_1' : tool.short_name) : (tool.icon === 'red-pen' ? '1' : '')"
                                :color="catalogValues.catalog_1 ? catalogValues.catalog_1 : '#000000'"
                                :middle-text="tool.icon === 'red-pen' ? '!' : '1'"
                                :tool-icon="tool.icon"
                                :tool-type="tool.type"
                                :top-text="tool.show_upper_detail ? (catalogValues.catalog_2 ? catalogValues.catalog_2 : 'Detail') : ''"
                            ></Icon>
                        </div>
                    </div>

                    <div v-for="index in 20" :key="index" class="form-group">
                        <template
                            v-if="index !== 1 && tool['catalog_' + index] && tool['catalog_' + index + '_values'].length > 0">

                            <label :for="'toolCatalog_' + index">{{ tool['catalog_' + index] }}</label>
                            <b-form-select
                                :id="'toolCatalog_' + index"
                                v-model="catalogValues['catalog_' + index]"
                                value="null">
                                <b-form-select-option :value="null"
                                                      v-text="''"></b-form-select-option>
                                <b-form-select-option v-for="catalogValue in tool['catalog_' + index + '_values']"
                                                      :key="catalogValue.value" :value="catalogValue.value"
                                                      v-text="catalogValue.text">
                                </b-form-select-option>
                            </b-form-select>
                        </template>
                    </div>

                    <div v-for="index in 20" v-if="hasTextBox && index > 1 && tool['text_' + index] !== null"
                         :key="index + '_text'"
                         class="form-group">
                        <label :for="'toolText_' + index">{{ tool['text_' + index] }}</label>

                        <input v-model="textBoxValues['text_' + index]" :placeholder="tool['text_' + index]"
                               class="form-control" maxlength="255"
                               name="short_name"
                               required
                               type="text"/>
                    </div>


                    <div class="form-group">
                        <label for="toolDescription">{{ $t('Description') }}</label>
                        <textarea id="toolDescription" :placeholder="$t('Write description here')" class="form-control"
                                  maxlength="255" name="toolDescription" rows="5"></textarea>
                    </div>

                    <div v-if="tool.catalog_1" class="approvals">
                        <div v-for="catalogValue in tool.catalog_1_values" class="row mb-3 cursor-pointer"
                             @click="catalog1Value = catalogValue; catalogValues.catalog_1 = catalogValue.value">
                            <div class="col-1 offset-2">
                                <div
                                    :style="{borderStyle: 'solid ', borderColor: catalogValue.value, borderWidth : '2px'}"
                                    class="color">
                                    <svg v-if="catalog1Value === catalogValue" class="icon-img disabled" height="100%"
                                         width="100%">
                                        <use xlink:href="#check-mark"></use>
                                    </svg>
                                </div>
                            </div>
                            <div class="col-9" v-text="catalogValue.text"></div>
                        </div>
                    </div>

                    <p class="info text-center mt-5" v-html="$t('Camera and gallery functions as a default')"></p>


                </div>
            </div>
        </template>
    </div>

</template>

<script>


import axios from "axios";
import Icon from "./Icon";
import ApprovalColorPicker from "./ApprovalColorPicker";


export default {
    name: "FireStop",
    components: {Icon, ApprovalColorPicker},
    data() {
        return {
            maxCustomApprovalColors: 2,
            detailName: '',
            selectedProduct: null,

            selectedDetail: null,
            catalog1Value: null,
            catalogValues: {
                catalog_1: null,
                catalog_2: null,
                catalog_3: null,
                catalog_4: null,
                catalog_5: null,
                catalog_6: null,
                catalog_7: null,
                catalog_8: null,
                catalog_9: null,
                catalog_10: null,
                catalog_11: null,
                catalog_12: null,
                catalog_13: null,
                catalog_14: null,
                catalog_15: null,
                catalog_16: null,
                catalog_17: null,
                catalog_18: null,
                catalog_19: null,
                catalog_20: null,
            },
            textBoxValues: {
                text_1: null,
                text_2: null,
                text_3: null,
                text_4: null,
                text_5: null,
                text_6: null,
                text_7: null,
                text_8: null,
                text_9: null,
                text_10: null,
                text_11: null,
                text_12: null,
                text_13: null,
                text_14: null,
                text_15: null,
                text_16: null,
                text_17: null,
                text_18: null,
                text_19: null,
                text_20: null
            },

            errors: {
                long_name: null,
                short_name: null,
                icon: null,
                catalog_1: null,
                catalog_2: null,
                catalog_3: null,
                catalog_4: null,
                catalog_5: null,
                catalog_6: null,
                catalog_7: null,
                catalog_8: null,
                catalog_9: null,
                catalog_10: null,
                catalog_11: null,
                catalog_12: null,
                catalog_13: null,
                catalog_14: null,
                catalog_15: null,
                catalog_16: null,
                catalog_17: null,
                catalog_18: null,
                catalog_19: null,
                catalog_20: null,

                catalog_1_values: null,
                catalog_2_values: null,
                catalog_3_values: null,
                catalog_4_values: null,
                catalog_5_values: null,
                catalog_6_values: null,
                catalog_7_values: null,
                catalog_8_values: null,
                catalog_9_values: null,
                catalog_10_values: null,
                catalog_11_values: null,
                catalog_12_values: null,
                catalog_13_values: null,
                catalog_14_values: null,
                catalog_15_values: null,
                catalog_16_values: null,
                catalog_17_values: null,
                catalog_18_values: null,
                catalog_19_values: null,
                catalog_20_values: null,

                text_1: null,
                text_2: null,
                text_3: null,
                text_4: null,
                text_5: null,
                text_6: null,
                text_7: null,
                text_8: null,
                text_9: null,
                text_10: null,
                text_11: null,
                text_12: null,
                text_13: null,
                text_14: null,
                text_15: null,
                text_16: null,
                text_17: null,
                text_18: null,
                text_19: null,
                text_20: null,

            },
            products: [],
            maxSelectOptions: 30,
        };
    },
    props: {
        tool: {
            type: Object,
            required: false,
            default: null
        },
        step: {
            type: Number,
            required: true,
            default: null
        },
        locale: {
            type: String,
            required: true,
            default: 'en'
        }
    },
    mounted() {
        this.getProjectProducts().then(() => this.getProducts());


        if (!this.tool.id) {
            this.tool.catalog_2 = this.$t('Detail');
        }
    },
    methods: {
        addEmptyTextBox() {
            for (let i = 2; i <= 20; i++) {
                if (this.tool['text_' + i] === null) {
                    this.enableTextBox(i);
                    return false;
                }
            }
        },
        enableTextBox(textBoxNr) {
            this.tool['text_' + textBoxNr] = '';
        },
        disableTextBox(textBoxNr) {
            this.tool['text_' + textBoxNr] = null;
        },
        disableCatalog(catalogNr) {
            this.tool['catalog_' + catalogNr] = null;
            this.tool['catalog_' + catalogNr + '_values'] = [];
        },
        toggleTextBoxInputs() {
            if (this.tool.has_text_boxes) {
                this.tool.has_text_boxes = false;

                for (let i = 2; i <= 20; i++) {
                    this.disableTextBox(i);
                }
            } else {
                this.tool.has_text_boxes = true;
                if (!this.tool.text_2) {
                    this.tool.text_2 = '';
                }
            }
        },
        addEmptyCatalog() {
            for (let i = 8; i <= 20; i++) {
                if (this.tool['catalog_' + i] === null) {
                    this.enableCatalog(i);
                    return false;
                }
            }
        },
        confirmRemoveCatalog(catalogNr) {
            this.$bvModal.msgBoxConfirm('Are you sure you want to delete this select box?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'md',
                okVariant: 'danger',
                okTitle: 'Delete',
                cancelTitle: 'Cancel',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if (value) {
                    this.disableCatalog(catalogNr);
                }
            });

        },
        removeCatalogValue(catalogIndex, valueIndex) {
            this.tool['catalog_' + catalogIndex + '_values'].splice(valueIndex, 1);
        },
        toggleCatalogInputs() {
            if (this.hasCatalog) {
                for (let i = 8; i <= 20; i++) {
                    this.disableCatalog(i);
                }
            } else {
                this.tool.has_catalogs = true;
                if (!this.tool.catalog_8) {
                    this.enableCatalog(8);
                }
            }
        },
        enableCatalog(catalogNr) {
            this.tool['catalog_' + catalogNr] = '';
            this.tool['catalog_' + catalogNr + '_values'] = [{text: '', value: ''}];
        },
        toggleCatalog(catalogNr, title, values) {
            if (this.tool['catalog_' + catalogNr]) {
                this.tool['catalog_' + catalogNr] = null;
                this.tool['catalog_' + catalogNr + '_values'] = [];
            } else {
                this.tool['catalog_' + catalogNr] = title;

                if (values) {
                    this.tool['catalog_' + catalogNr + '_values'] = values;
                } else {
                    this.tool['catalog_' + catalogNr + '_values'] = [];
                }
            }
        },
        addApprovalColor() {
            if (this.tool.catalog_1_values.length < 3 + this.maxCustomApprovalColors) {
                this.tool.catalog_1_values.push({value: '#D1D5DB', text: ''});
            }
        },

        removeApprovalColor(index) {
            this.tool.catalog_1_values.splice(index, 1);
        },

        changeCatalogValue(catalogNr, key, value) {
            this.tool['catalog_' + catalogNr + '_values'][key] = {
                value: value,
                text: value
            };
        },
        addValueToCatalog(value, text, catalogNr) {
            if (this.tool['catalog_' + catalogNr + '_values']) {
                this.tool['catalog_' + catalogNr + '_values'].push({value: value, text: text});
            } else {
                this.tool['catalog_' + catalogNr + '_values'] = [{value: value, text: text}];
            }
        },
        async getProjectProducts() {

            const data = {
                is_public: 1
            };

            let token = this.$store.state.token;
            let url = this.$store.getters.apiProjectBase + '/products';
            let method = 'GET';

            try {
                let response = await axios({
                    url: url,
                    params: data,
                    method: method,
                    headers: {"Authorization": "Bearer " + token}
                });
                if (!this.tool.catalog_5_values || this.tool.catalog_5_values.length === 0) {
                    response.data.data.forEach(product => {
                        this.addProductToTool(product);
                    });
                }
            } catch (error) {
                alert('Something went wrong');
                console.log(error);
            }
        },
        getProducts() {

            const data = {
                is_public: 1,
                paginate: 0
            };

            const url = this.$store.getters.apiProjectBase + '/products/search';
            let method = 'GET';
            let token = this.$store.state.token;

            axios({
                url: url,
                params: data,
                method: method,
                headers: {"Authorization": "Bearer " + token}
            })
                .then(response => {
                    this.products = response.data.data;
                })
                .catch(error => {
                    alert('Something went wrong');
                });
        },
        addProductToTool(product) {
            if (product) {

                const productIndex = _.findIndex(this.tool.catalog_5_values, function (catalogValue) {
                    return catalogValue.value === product.id;
                });

                if (productIndex >= 0) {
                    this.tool.catalog_5_values.splice(productIndex, 1);
                    this.tool.catalog_6_values.splice(productIndex, 1);
                    this.tool.catalog_7_values.splice(productIndex, 1);
                } else {
                    const productName = product.name + (product.eta_ce ? (' (' + product.eta_ce + ')') : '');

                    this.addValueToCatalog(product.id, productName, 5);
                    this.addValueToCatalog(product.id, productName, 6);
                    this.addValueToCatalog(product.id, productName, 7);
                }

                this.checkProducts();

                this.selectedProduct = null;

            }

        },
        deleteProductByKey(key) {
            this.tool.catalog_5_values.splice(key, 1);
            this.tool.catalog_6_values.splice(key, 1);
            this.tool.catalog_7_values.splice(key, 1);
            this.checkProducts();
        },
        checkProducts() {
            if (this.tool.catalog_5_values && this.tool.catalog_5_values.length > 0) {
                this.tool.catalog_5 = this.$t('Product') + ' 1';
                this.tool.catalog_6 = this.$t('Product') + ' 2';
                this.tool.catalog_7 = this.$t('Product') + ' 3';
            } else {
                this.tool.catalog_5 = null;
                this.tool.catalog_6 = null;
                this.tool.catalog_7 = null;
            }
        },
    },
    computed: {
        hasEmptyTextBox() {
            return this.tool.text_2 === null ||
                this.tool.text_3 === null ||
                this.tool.text_4 === null ||
                this.tool.text_5 === null ||
                this.tool.text_6 === null ||
                this.tool.text_7 === null ||
                this.tool.text_8 === null ||
                this.tool.text_9 === null ||
                this.tool.text_10 === null ||
                this.tool.text_11 === null ||
                this.tool.text_12 === null ||
                this.tool.text_13 === null ||
                this.tool.text_14 === null ||
                this.tool.text_15 === null ||
                this.tool.text_16 === null ||
                this.tool.text_17 === null ||
                this.tool.text_18 === null ||
                this.tool.text_19 === null ||
                this.tool.text_20 === null;
        },
        hasTextBox() {
            return this.tool.has_text_boxes;
        },
        customInputCount() {
            let arr = [
                this.tool.catalog_8,
                this.tool.catalog_9,
                this.tool.catalog_10,
                this.tool.catalog_11,
                this.tool.catalog_12,
                this.tool.catalog_13,
                this.tool.catalog_14,
                this.tool.catalog_15,
                this.tool.catalog_16,
                this.tool.catalog_17,
                this.tool.catalog_18,
                this.tool.catalog_19,
                this.tool.catalog_20,
                this.tool.text_2,
                this.tool.text_3,
                this.tool.text_4,
                this.tool.text_5,
                this.tool.text_6,
                this.tool.text_7,
                this.tool.text_8,
                this.tool.text_9,
                this.tool.text_10,
                this.tool.text_11,
                this.tool.text_12,
                this.tool.text_13,
                this.tool.text_14,
                this.tool.text_15,
                this.tool.text_16,
                this.tool.text_17,
                this.tool.text_18,
                this.tool.text_19,
                this.tool.text_20
            ];

            return arr.filter(customInput => {
                return customInput !== null;
            }).length;
        },
        hasCatalog() {
            return this.tool.catalog_8 !== null ||
                this.tool.catalog_9 !== null ||
                this.tool.catalog_10 !== null ||
                this.tool.catalog_11 !== null ||
                this.tool.catalog_12 !== null ||
                this.tool.catalog_13 !== null ||
                this.tool.catalog_14 !== null ||
                this.tool.catalog_15 !== null ||
                this.tool.catalog_16 !== null ||
                this.tool.catalog_17 !== null ||
                this.tool.catalog_18 !== null ||
                this.tool.catalog_19 !== null ||
                this.tool.catalog_20 !== null;
        },
        defaultStatuses() {
            return [
                {value: this.$t('Installed'), text: this.$t('Installed')},
                {value: this.$t('Designed'), text: this.$t('Designed')},
                {value: this.$t('Preliminary'), text: this.$t('Preliminary')},
            ];
        },
        defaultLocations() {
            return [
                {value: this.$t('On the floor'), text: this.$t('On the floor')},
                {value: this.$t('On the ceiling'), text: this.$t('On the ceiling')},
                {value: this.$t('On the wall'), text: this.$t('On the wall')},

            ];
        },
        defaultApprovals() {
            return [
                {value: '#A91E23', text: this.$t('Not approved')},
                {value: '#F8B133', text: this.$t('Waiting')},
                {value: '#008D36', text: this.$t('Approved')},
            ];
        },
    },
    watch: {
        locale(val) {
            this.$i18n.locale = val
        },

        step(newStep, oldStep) {
            let hasErrors = false;

            if (newStep === 5) {
                if (!this.tool.long_name) {
                    this.errors.long_name = this.$t('Tool long name is required');
                    hasErrors = true;
                }

                if (!this.tool.short_name) {
                    this.errors.short_name = this.$t('Tool short name is required');
                    hasErrors = true;
                }
            } else if (newStep === 6) {
                if (this.tool['catalog_2'] !== null) {
                    this.tool['catalog_2_values'].forEach(catalogValue => {
                        if (!catalogValue || (catalogValue.text !== 0 && !catalogValue.text)) {
                            this.errors['catalog_2_values'] = this.$t('Detail name can not be empty');
                            hasErrors = true;
                        }
                    });
                }
            } else if (newStep === 8) {
                if (this.tool['catalog_1'] !== null) {
                    this.tool['catalog_1_values'].forEach(catalogValue => {
                        if (!catalogValue || (catalogValue.text !== 0 && !catalogValue.text)) {
                            this.errors['catalog_1_values'] = this.$t('Approval text can not be empty');
                            hasErrors = true;
                        }
                    });
                }

                if (this.tool['catalog_3'] !== null) {
                    this.tool['catalog_3_values'].forEach(catalogValue => {
                        if (!catalogValue || (catalogValue.text !== 0 && !catalogValue.text)) {
                            this.errors['catalog_3_values'] = this.$t('Status text can not be empty');
                            hasErrors = true;
                        }
                    });
                }

                if (this.tool['catalog_4'] !== null) {
                    this.tool['catalog_4_values'].forEach(catalogValue => {
                        if (!catalogValue || (catalogValue.text !== 0 && !catalogValue.text)) {
                            this.errors['catalog_4_values'] = this.$t('Location text can not be empty');
                            hasErrors = true;
                        }
                    });
                }


            } else if (newStep === 9) {
                if (this.tool.has_catalogs) {
                    for (let i = 8; i <= 20; i++) {
                        if (this.tool['catalog_' + i] !== null) {
                            if (!this.tool['catalog_' + i]) {
                                this.errors['catalog_' + i] = this.$t('Dropdown headline can not be empty');
                                hasErrors = true;
                            }

                            this.tool['catalog_' + i + '_values'].forEach(catalogValue => {
                                if (!catalogValue || (catalogValue.text !== 0 && !catalogValue.text)) {
                                    this.errors['catalog_' + i + '_values'] = this.$t('Selection text entry can not be empty');
                                    hasErrors = true;
                                }
                            });
                        }
                    }
                }
            }

            if (hasErrors) {
                this.$emit('jumpToStep', oldStep);
            }
        },
    }
}
</script>

<style scoped>
label {
    padding: 0;
    margin: 0;
}
</style>
